import { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import type { DeltaStatic as Delta } from "quill";

interface RecordContentProps {
  content: string;
  formattedContent?: Delta;
}

export function RecordContent({
  content,
  formattedContent,
}: RecordContentProps) {
  const quillRef = useRef<ReactQuill>(null);

  if (formattedContent) {
    return (
      <div className="max-h-32 overflow-y-auto">
        <ReactQuill
          ref={quillRef}
          value={formattedContent}
          readOnly
          theme="bubble"
          modules={{ toolbar: false }}
        />
      </div>
    );
  }

  // Fallback to plain text if no formatted content
  return (
    <div className="max-h-32 overflow-y-auto text-sm text-brand-text">
      {content}
    </div>
  );
}
